import { useQuery } from '@tanstack/react-query';
import type { IGetCourseFormOptionsResponse } from '@treneo/models';
import { ResultHelpers } from '@treneo/models';

import { configApi } from './api';
import { COURSE_FORM_OPTIONS_QUERY_KEY } from './config-query-keys';

export { COURSE_FORM_OPTIONS_QUERY_KEY } from './config-query-keys';

const getCourseFormOptionsQueryFn = async (): Promise<IGetCourseFormOptionsResponse> => {
  const result = await configApi.getCourseFormOptions();
  return ResultHelpers.unwrap(result, 'Get course form options failed');
};

export const getCourseFormOptionsQueryOptions = () =>
  ({
    queryKey: COURSE_FORM_OPTIONS_QUERY_KEY,
    queryFn: getCourseFormOptionsQueryFn,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  }) as const;

type UseCourseFormOptionsQueryParams = {
  enabled?: boolean;
};

export const useCourseFormOptionsQuery = (params?: UseCourseFormOptionsQueryParams) => {
  const enabled = params?.enabled ?? true;
  return useQuery({
    ...getCourseFormOptionsQueryOptions(),
    enabled
  });
};
